import { render } from "./predictedPerformance.vue?vue&type=template&id=1c12deb5&scoped=true"
import script from "./predictedPerformance.vue?vue&type=script&lang=js"
export * from "./predictedPerformance.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1c12deb5"]])

export default __exports__